import React from 'react';
import { Button } from '@vds/buttons';
import ModalOverlay from './../../../components/modalOverlay';
import { updateSCTags } from './../../../service/change/dtmTag';
import { InHomeUtils } from './../../../util/inhomeUtils';
import { ModalTitle, ModalBody } from '@vds/modals';
import {formatPerks} from "../../midnight/services/dataFormatter";
import {Perk} from "@plans/tiles";
import constants from "../perks/constants";
import { dataTrack } from './../../../service/change/vzdl';
import $ from 'jquery';
class PerksOverlay extends React.PureComponent {

    noThanks = () => {
        updateSCTags("no thanks","","Zero Perk Upsell Modal - Netflix and Max (with ads)");
        this.props.dispatch({ type: "UPDATE_PERK_OVERLAY_VALUE", value: 'opened' });
        this.props.checkout();
    }

    continueShopping = () => {
        updateSCTags("Start Saving","","Zero Perk Upsell Modal - Netflix and Max (with ads)");
        this.props.dispatch({ type: "UPDATE_PERK_OVERLAY_VALUE", value: 'opened' });
        this.props.dispatch({ type: "TOGGLE_PERKS_ACCOR", value: true });
        let getEleOfPerkAccordion = document.getElementById('PerkAccordionID');
        let getTopOFPerkAccordion = getEleOfPerkAccordion.offsetTop;
        console.log(getTopOFPerkAccordion,'getTopOFPerkAccordion');
        $(window).scrollTop(getTopOFPerkAccordion);
        document.getElementById('PerkAccordionID').scrollIntoView({behavior: "smooth"});
        this.props.closeModal();
    }

    render() {
        let upsellContent = '';
        const centerStyle = { textAlign : 'center'};
        if (this.props.modalWindow.modalId === "URCPerksOverlay") {
            const formatProdForPerk = (product) => {
                let isEmployee = (InHomeUtils.isNotNull(this.props.lqState) && this.props.lqState.couponFlowType === "Employee");
                const empDiscount = isEmployee ? 5 : 0;
                const oldPricesArray = product?.perkDetails?.map(prod => (prod?.perkOriginalPrice - prod?.chargePrice + empDiscount).toFixed(2));
                let perkActPrice = product?.perkDetails?.[0]?.perkOriginalPrice;
                const perkMrp = product?.perkDetails?.[0]?.productKeyword?.split?.('MRP:')?.[1];
                if (perkMrp && !(Array.isArray(oldPricesArray) && oldPricesArray?.length > 1)) {
                  perkActPrice = parseFloat(perkMrp?.split('|')?.[0]);
                }
                const unlimitedCloudStorage = (product?.perkDetails?.[0]?.id === constants.UNLIMITED_CLOUD_INDIVIDUAL);    
                const homeDevice = (product?.perkDetails?.[0]?.id === constants.HOME_DEVICE_ADVISOR);
                const applesOneIndividual = (product?.perkDetails?.[0]?.id === constants.APPLE_ONE_INDIVIDUAL);
                let applesOneIndividualNewPrice = '';
                if(applesOneIndividual) {
                  const applesOneIndividualPerkPrice1 = isEmployee ? product?.perkDetails?.[0]?.price/2 : product?.perkDetails?.[0]?.price;
                  if(InHomeUtils.isNotEmpty(product?.perkDetails?.[1]?.id)){
                    const gapplesOneIndividualPerkPrice2 = isEmployee && product?.perkDetails?.[1]?.id !== 'R3784' ? product?.perkDetails?.[1]?.price/2 : product?.perkDetails?.[1]?.price;
                    applesOneIndividualNewPrice = applesOneIndividualPerkPrice1 + ' - $' + gapplesOneIndividualPerkPrice2
                  }
                }   
                const elementBg =
                  product?.perkDetails?.[0]?.perkTextAppearance?.toLowerCase() == "light" || product?.perkDetails?.[0]?.id === constants.UNLIMITED_CLOUD_INDIVIDUAL 
                    ? "dark"
                    : "light";
                const obj =   {
                  aspectRatio: "1/1",
                  backgroundImage: {
                    baseUrl: "https://ss7.vzw.com/is/image/VerizonWireless/",
                    variant: "default",
                    perkName: product?.perkDetails?.[0]?.backgroundImage,
                    queryParams: {
                      fmt: "webp",
                    },
                  },
                  elementSurface: elementBg,
                  variant: "button",
                  title: {
                    children: <span className= "wraptext" style={{fontSize: '20px', lineHeight: '24px'}} aria-hidden="true">{product?.perkDetails?.[0]?.displayName}</span>,
                    type: "title",
                  //  underline: true,
                    color: 
                      product?.perkDetails?.[0]?.perkTextAppearance?.toLowerCase() == "light" ||
                      product?.perkDetails?.[0]?.id === constants.UNLIMITED_CLOUD_INDIVIDUAL 
                      ? 'white' : 'black',
                      
                  },
                  ...(unlimitedCloudStorage && { oldPrice: {
                    price: isEmployee ? '8.99' : '3.99',
                    leadingText: {
                      children: 'Save '
                    },
                    term: 'month'
                  }}),
                  ...(!homeDevice && { oldPrice: {
                    price:  Array.isArray(oldPricesArray) && oldPricesArray.length > 1
                      ? Math.max(...oldPricesArray)
                      : `${(
                        perkActPrice - (isEmployee ? parseFloat(product?.perkDetails?.[0]?.chargePrice)/2 : product?.perkDetails?.[0]?.chargePrice)
                      ).toFixed(2)?.replace(/\.00$/, '')}`,
                    term: "month",
                  }}),
                  ...(homeDevice && { oldPrice: {
                    price: isEmployee ? '10' : '5',
                    leadingText: {
                      children: 'Save up to'
                    },
                    trailingText: {
                      children: "on Home Device Advisor"
                    },
                    term: 'month'
                  }}),
                  newPrice: {
                    price: homeDevice ? (isEmployee ? '5 - $25' : '10 - $25') : unlimitedCloudStorage ? (isEmployee ? '5 - $7.5' : '10 - $15') : applesOneIndividual ? applesOneIndividualNewPrice : (isEmployee && product?.perkDetails?.[0].id == 'R3558' ? (product?.perkDetails?.[0]?.chargePrice / 2) : (parseInt(product?.perkDetails?.[0]?.chargePrice) - empDiscount)),
                    term: "month",
                  },
                  image: {
                    src: product?.perkDetails?.[0]?.perkLogo,
                    alt: product?.perkDetails?.[0]?.name,
                  },
                  height: '309px'
                };
                return obj;
            };
            let eligiblePerk = this.props?.buildProduct?.perks?.plans?.find(product => product?.productId === "R3559");
            if(!InHomeUtils.isNotNull(eligiblePerk)){
                eligiblePerk = this.props?.buildProduct?.perks?.plans[0];
            }
            const isMobile = (window.screen.width < 768) ? true : false;
            upsellContent = (
                <div>
                    <div style={isMobile ? {width: '288px'} : {}}>
                        <ModalTitle>Don’t forget about these perks</ModalTitle>
                    </div>
                    <div>
                        <div className="tiny-margin-top-large">
                            <Perk {...formatProdForPerk(formatPerks(eligiblePerk,this.props?.buildProduct,this.props.lqState))} />
                        </div>
                        <div className="row" style={{marginTop: isMobile ? '52px' : '32px'}}>
                            <div className="columns tiny-12 small-6 margin-top-tiny">
                                <Button data-track={dataTrack('link','start saving | modal')} width="100%" onClick={this.continueShopping} size="large">Start saving</Button>
                            </div>
                            <div className="columns tiny-12 small-6 margin-top-tiny">
                                <Button data-track={dataTrack('link','no thanks | modal')} use="secondary" width="100%" onClick={this.noThanks} size="large">No thanks</Button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <ModalOverlay noThanks={this.noThanks} id="URCPerksOverlay" template={upsellContent} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch} />
        );
    }
}


export default PerksOverlay;